import { useQuery } from '@tanstack/react-query';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { AppConfigResponseDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Return = {
  appConfig: AppConfigResponseDto | undefined;
  isErrorGettingAppConfig: boolean;
  isPendingAppConfig: boolean;
};

export const useGetAppConfig = (): Return => {
  const { appConfigApi } = useApiClient();

  const { data, isError, isPending } = useQuery<AppConfigResponseDto>({
    queryFn: async () => {
      const { data } = await appConfigApi.getAppConfig();
      return data;
    },
    queryKey: [QueryKeyEnum.APP_CONFIG],
    staleTime: Number.POSITIVE_INFINITY,
  });

  return {
    appConfig: data,
    isErrorGettingAppConfig: isError,
    isPendingAppConfig: isPending,
  };
};
